module.exports = __webpack_public_path__ + "static/media/btn-nav-mobile-expanded.8a39f9ed.svg";